if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Setup size validation UI
        this.setupSizeValidation();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Check if size is required and selected
        if (!this.validateSizeSelection()) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Check if we need to add pre-selected stack items with main product
        const pairedDrawer = document.getElementById('stack-drawer');
        const stackMode = pairedDrawer ? pairedDrawer.dataset.stackMode : null;
        
        if (stackMode === 'pre_select' && window.hasPreSelectedStackItems && window.hasPreSelectedStackItems()) {
          // Add main product + pre-selected items together
          this.addMainProductWithPreSelectedItems(evt);
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
              
              // Check for paired products and open drawer after a small delay (auto_open mode only)
              setTimeout(() => {
                this.checkAndOpenPairedProductsDrawer();
              }, 100);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      checkAndOpenPairedProductsDrawer() {
        // Check if paired products drawer exists
        const pairedDrawer = document.getElementById('stack-drawer');
        if (!pairedDrawer) {
          console.log('Paired products drawer not found - either setting is disabled or no paired products exist');
          return;
        }

        // Only auto-open in auto_open mode
        const stackMode = pairedDrawer.dataset.stackMode || 'auto_open';
        if (stackMode !== 'auto_open') {
          console.log('Stack drawer is in', stackMode, 'mode - not auto-opening');
          return;
        }

        // Check if there are actually products in the drawer
        const hasProducts = pairedDrawer.querySelector('.stack-product');
        if (!hasProducts) {
          console.log('No paired products available in drawer');
          return;
        }

        // Get SIZE property value if it exists
        const sizeInput = this.form.querySelector('[name="properties[Size]"]');
        const sizeValue = sizeInput ? sizeInput.value : '';

        console.log('Opening paired products drawer with SIZE:', sizeValue);

        // Open the paired products drawer with SIZE property
        if (window.openPairedProductsDrawer) {
          window.openPairedProductsDrawer(sizeValue);
        } else {
          console.error('openPairedProductsDrawer function not found');
        }
      }

      async addMainProductWithPreSelectedItems(evt) {
        // This method adds main product + pre-selected stack items together
        if (!window.getPreSelectedStackItems) {
          console.error('getPreSelectedStackItems function not available');
          this.resetSubmitButton();
          return;
        }

        try {
          const preSelectedItems = window.getPreSelectedStackItems();
          
          // Always get the current size value from the form (not from stored value)
          const sizeInput = this.form.querySelector('[name="properties[Size]"]');
          const sizeValue = sizeInput ? sizeInput.value : '';
          
          console.log('Adding main product + stack items with current SIZE:', sizeValue);
          
          const productsToAdd = [];
          
          // Add main product
          const mainFormData = new FormData(this.form);
          productsToAdd.push(mainFormData);
          
          // Add pre-selected stack items with the current size
          preSelectedItems.forEach(product => {
            const formData = new FormData();
            formData.append('id', product.variantId);
            formData.append('quantity', '1');
            // Always apply the current size to stack products
            if (sizeValue) {
              formData.append('properties[Size]', sizeValue);
            }
            productsToAdd.push(formData);
          });

          // Add all products sequentially
          for (let i = 0; i < productsToAdd.length; i++) {
            const formData = productsToAdd[i];
            const isLast = i === productsToAdd.length - 1;

            // Only get sections on the last item to show all in cart notification
            if (this.cart && isLast) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
            }

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            const response = await fetch(`${routes.cart_add_url}`, config);
            const data = await response.json();

            if (data.status) {
              this.handleErrorMessage(data.description);
              console.error('Error adding product:', data);
              this.resetSubmitButton();
              return;
            }

            // Render cart on the last item
            if (isLast && this.cart) {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(data);
              });
              
              // Clear pre-selected items
              if (window.clearPreSelectedStackItems) {
                window.clearPreSelectedStackItems();
              }
              
              CartPerformance.measureFromEvent("add:user-action", evt);
            }
          }

          this.resetSubmitButton();
        } catch (error) {
          console.error('Error adding products:', error);
          this.resetSubmitButton();
        }
      }

      resetSubmitButton() {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      }

      setupSizeValidation() {
        // Check if there's a size dropdown on the page
        const sizeDropdown = document.querySelector('[data-dropdown-type="size"]');
        if (!sizeDropdown) {
          // No size selector, so no validation needed
          return;
        }

        // Listen for size changes to update button state
        const sizeInput = this.form.querySelector('[name="properties[Size]"]');
        if (sizeInput) {
          sizeInput.addEventListener('change', () => {
            this.updateSizeValidationState();
          });
        }

        // Listen for custom dropdown size changes (immediate feedback)
        sizeDropdown.addEventListener('size:change', (event) => {
          // Update the hidden input immediately
          if (sizeInput) {
            sizeInput.value = event.detail.value;
            this.updateSizeValidationState();
          }
        });

        // Also listen for the general dropdown change event
        sizeDropdown.addEventListener('dropdown:change', (event) => {
          if (event.detail && event.detail.value) {
            // Update the hidden input immediately
            if (sizeInput) {
              sizeInput.value = event.detail.value;
              this.updateSizeValidationState();
            }
          }
        });

        // Initial state check
        this.updateSizeValidationState();
        
        // Setup stack display updates for pre_select mode
        this.setupStackDisplayUpdates();
      }

      updateSizeValidationState() {
        const sizeInput = this.form.querySelector('[name="properties[Size]"]');
        const selectedSize = sizeInput ? sizeInput.value : '';
        const hasSize = selectedSize && selectedSize.trim() !== '';

        // Update button state
        if (hasSize) {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.disabled = false;
        } else {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.disabled = true;
        }
      }

      validateSizeSelection() {
        // Check if there's a size dropdown on the page
        const sizeDropdown = document.querySelector('[data-dropdown-type="size"]');
        if (!sizeDropdown) {
          // No size selector, so no validation needed
          return true;
        }

        // Check if size is selected
        const sizeInput = this.form.querySelector('[name="properties[Size]"]');
        const selectedSize = sizeInput ? sizeInput.value : '';
        
        if (!selectedSize || selectedSize.trim() === '') {
          // Show error message
          this.handleErrorMessage('Please select a size before adding to cart');
          
          // Focus the size dropdown to help user
          const sizeTrigger = sizeDropdown.querySelector('[data-dropdown-trigger]');
          if (sizeTrigger) {
            sizeTrigger.focus();
          }
          
          return false;
        }
        
        // Clear any previous error messages
        this.handleErrorMessage();
        return true;
      }

      setupStackDisplayUpdates() {
        // Listen for variant changes to update stack display
        this.form.addEventListener('variant:change', (event) => {
          if (window.updateStackProductDisplay) {
            window.updateStackProductDisplay();
          }
        });

        // Also listen for the pub-sub variant change event
        if (window.subscribe) {
          window.subscribe('variantChange', () => {
            if (window.updateStackProductDisplay) {
              setTimeout(() => window.updateStackProductDisplay(), 100);
            }
          });
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
